import * as React from 'react'
import { StyledSelect, SelectWrapper, StyledOption, Arrow } from '$views/components/NativeSelect/NativeSelect.style'
import { VerticalMarginProps, HorizontalMarginProps } from '$utils/theme/css'

interface Option extends React.OptionHTMLAttributes<HTMLOptionElement> {}

export interface Props extends React.SelectHTMLAttributes<any> {
  options: Option[]
  placeholder?: string
  defaultValue?: string
  width?: number
  onChange?: (value: any) => void
  bordered?: any
  onFocus?: () => void
}

interface State {
  options: Option[]
}

export class NativeSelect extends React.Component<Props & VerticalMarginProps & HorizontalMarginProps, State> {
  state = {
    options: this.props.options,
  }

  componentDidMount() {
    const fullOptionList = this.setPlaceholderAsFirstOption()

    this.setState({
      options: fullOptionList,
    })
  }

  handleSelectChange = event => {
    const selectedOption = this.state.options.find(option => option.value === event.currentTarget.value)
    if (this.props.onChange) {
      this.props.onChange(selectedOption)
    }
  }

  setPlaceholderAsFirstOption = () => {
    const { options, placeholder } = this.props
    if (placeholder) {
      const placeHolderOption = [{ value: '', label: placeholder, disabled: true } as Option]
      return placeHolderOption.concat(options)
    }

    return options
  }

  render() {
    const { options } = this.state
    const { marginBottom, marginLeft, marginRight, marginTop, defaultValue, onFocus } = this.props
    return (
      <SelectWrapper
        bordered={this.props.bordered}
        width={this.props.width}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginTop={marginTop}
      >
        <StyledSelect onChange={this.handleSelectChange} value={defaultValue} onFocus={onFocus}>
          {options.map((option, index) => (
            <StyledOption
              key={index}
              value={option.value}
              disabled={option.disabled}
              isPLaceholder={option.value === ''}
            >
              {option.label}
            </StyledOption>
          ))}
        </StyledSelect>
        <Arrow />
      </SelectWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/components/NativeSelect/NativeSelect.tsx